const SquashMatchCalenderTypes = {
    GET_SQUASH_MATCH_CALENDER_START:'GET_SQUASH_MATCH_CALENDER_START',
    GET_SQUASH_MATCH_CALENDER_SUCCESS:'GET_SQUASH_MATCH_CALENDER_SUCCESS',
    GET_SQUASH_MATCH_CALENDER_FAILED:'GET_SQUASH_MATCH_CALENDER_FAILED',

}

export default SquashMatchCalenderTypes